// Module
var code = `<h2 data-bind="label:'cc_cannot_process_request'">We were unable to process your request.</h2>

<p></p>
<p data-bind="label:'cc_cannot_process_request_additional1'">Please contact Kyocera customer service at 902998491.</p>
<p data-bind="label:'cc_cannot_process_request_additional2'">Sorry for the inconvenience.</p>
`;
// Exports
module.exports = code;